/* RESET */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  border: 0;
  vertical-align: baseline;

  font-size: 100%;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none !important;
  padding-left: 0 !important;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after {
  content: '';
  content: none;
}

q:before,
q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

textarea {
  resize: none;
}

select {
  border: none;
  box-shadow: none;
  appearance: none;
  background-color: transparent;
  text-decoration: none;
}

/* MAIN  */

:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

*:focus {
  outline: none;
}

pre,
.text {
  white-space: pre-wrap;
}

b {
  font-weight: bold;
}

i {
  font-style: italic;
}

p {
  margin-bottom: 20px;
}

ol,
ul {
  padding-left: 30px;
}

ul {
  list-style: disc;
}

ol {
  list-style: decimal;
}

a {
  text-decoration: none;
  cursor: pointer;
}

figure {
  margin: 0;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0;
}

*,
*:after,
*:before {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

img[src=''],
img:not([src]) {
  opacity: 0;
}

.clearfix:before,
.clearfix:after {
  content: ' ';
  display: table;
}

.clearfix:after {
  clear: both;
}
